import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';
import DeleteModalSkeleton from '../../components/Skeletons/DeleteModalSkeleton';

const NewSecurityKeyModal = ({ securityKeyModal, loading, handleCreateKeyModalClose, handleCreateKey }) => {
	const { t } = useTranslation();
	return (
		<Modal show={securityKeyModal}>
			<ModalHeading heading={t('screens.chat.createSecurityKeyTitle')} />
			{loading ? (
				<DeleteModalSkeleton />
			) : (
				<ModalForm style={{ marginBottom: '2.5rem' }}>
					<InputsSection style={{ width: '34rem' }}>
						<p className='primaryText'>{t('screens.chat.createSecurityKeyPrompt')}</p>
					</InputsSection>
					<ModalButtons
						submitButtonLabel={t('screens.chat.createNew')}
						onSubmit={handleCreateKey}
						cancelButtonLabel={t('screens.chat.cancel')}
						onCancel={handleCreateKeyModalClose}
					/>
				</ModalForm>
			)}
		</Modal>
	);
};

export default NewSecurityKeyModal;
